/*
switchSettingRow.tsx
Copyright © 2026 Xerox Corporation. All Rights Reserved.

Copyright protection claimed includes all forms and matters of copyrightable material
and information now allowed by statutory or judicial law or hereinafter granted,
including without limitation, material generated from the software programs which
are displayed on the screen such as icons, screen display looks, etc.
*/
import XrxSwitch from './xrx-switch'
interface SwitchSettingRowProps {
  setting: string
  value: object | string | boolean | undefined
  setValue(data: boolean): void | boolean
  iconPath?: string
  clickable?: boolean
}
export default function SwitchRow (props: SwitchSettingRowProps) {
  const { iconPath, setting, value, setValue, clickable } = props
  return (
    <>
      {iconPath ? (
        <div className='left-object custom-icon-rounded'>
          <img src={iconPath} className='img-fluid' />
        </div>
      ) : (
        <></>
      )}
      <div className='content-container'>
        <div className='left-label pl-0'>
          <span className="switchrow-text">{setting}</span>
        </div>
        <div
          className='right-object'
          {...(clickable ? { onClick: () => setValue(!value) } : {})}
        >
          <XrxSwitch isChecked={!!value}></XrxSwitch>
        </div>
      </div>
    </>
  )
}
